/**
 * ContentHeaderSlot - Renders controls in the content-header location.
 *
 * This slot appears above the main content area and is typically used for
 * controls that need to be visible while browsing media.
 */

import React from 'react';

import {MediaBrowserPanelProps, MediaConfigWithDefaults} from '../../Component';
import {StepMeta} from '../../types';
import {SlotRegistry} from '../types';
import {ControlRenderer} from './ControlRenderer';

export type ContentHeaderSlotProps = {
  controls: NonNullable<SlotRegistry[keyof SlotRegistry]>;
  config: MediaConfigWithDefaults;
  updateConfig: MediaBrowserPanelProps['updateConfig'];
  stepMeta: StepMeta;
  currentStep: number;
  mediaIndex: number;
};

/**
 * Renders controls in the content-header location.
 *
 * @param props - Content header slot props
 * @returns Rendered controls in header layout
 */
export const ContentHeaderSlot: React.FC<ContentHeaderSlotProps> = ({
  controls,
  config,
  updateConfig,
  stepMeta,
  currentStep,
  mediaIndex,
}) => {
  return (
    <div className="flex items-center justify-center gap-4 p-4">
      {controls.map((control, idx) => (
        <ControlRenderer
          key={`header-control-${idx}`}
          control={control}
          index={idx}
          config={config}
          updateConfig={updateConfig}
          stepMeta={stepMeta}
          currentStep={currentStep}
          mediaIndex={mediaIndex}
        />
      ))}
    </div>
  );
};
